export interface SupportFeedbackCommentDTO {
  id: number;
  feedback_id: number;
  admin_id: number;
  admin_nickname?: string;
  admin_email?: string;
  content: string;
  image_count: number;
  created_at: string;
  image_data_urls?: string[];
}

export interface SupportFeedbackItemDTO {
  id: number;
  user_id: number;
  nickname?: string;
  email?: string;
  category: string;
  content: string;
  status: string;
  image_count: number;
  created_at: string;
  updated_at: string;
  image_data_urls?: string[];
  comments?: SupportFeedbackCommentDTO[];
}

export interface SupportFeedbackListResponseDTO {
  total: number;
  page: number;
  page_size: number;
  items: SupportFeedbackItemDTO[];
}

export type SupportFeedbackStatus = 'pending' | 'processing' | 'resolved';

export const SUPPORT_FEEDBACK_STATUS_LABELS: Record<SupportFeedbackStatus, string> = {
  pending: '待处理',
  processing: '处理中',
  resolved: '已解决',
};

export const ALL_SUPPORT_FEEDBACK_STATUSES: Array<'' | SupportFeedbackStatus> = [
  '',
  'pending',
  'processing',
  'resolved',
];

export type SupportFeedbackCategory =
  | 'task'
  | 'withdrawal'
  | 'account'
  | 'bug'
  | 'suggestion'
  | 'other';

export const SUPPORT_FEEDBACK_CATEGORY_LABELS: Record<SupportFeedbackCategory, string> = {
  task: '任务问题',
  withdrawal: '提现问题',
  account: '账号问题',
  bug: 'Bug 反馈',
  suggestion: '产品建议',
  other: '其他问题',
};
